import { createFileRoute } from "@tanstack/react-router";
import AdminOccasionsPage from "@/admin/pages/occasions";

export const Route = createFileRoute("/admin/occasions/")({
  component: AdminOccasionsPage,
});
